import { useNavigate } from "react-router-dom";
import { Button, Loading, Modal, Typography } from "@/components/atoms";
import { getErrorMessages } from "@/helpers/reduxHelpers";
import { useOperator } from "@/hooks";
import { useCreateVehicleMutation } from "@/redux/apis/vehicle/vehicleApi";
import { Vehicle } from "@/redux/slices/vehicle/types";
import { addToast } from "@/utils";
import { VehicleDetailsSummary } from "../common/VehicleDetailsSummary";

interface ConfirmVehicleModalProps {
  vehicle?: Vehicle;
  onCancel: () => void;
  onClose: () => void;
}

export const ConfirmVehicleModal = ({ vehicle, onCancel, onClose }: ConfirmVehicleModalProps) => {
  const navigate = useNavigate();
  const { id: operatorId } = useOperator();
  const [createVehicle, { isLoading }] = useCreateVehicleMutation();

  const handleConfirm = () => {
    if (!vehicle) return;

    createVehicle({
      registration_number: vehicle.registrationNumber,
      state_uuid: vehicle.state.uuid,
    })
      .unwrap()
      .then((createdVehicle) => {
        navigate(`/operator/${operatorId}/vehicles/my-vehicles/add/${createdVehicle.uuid}`);
        onClose();
      })
      .catch((e) => {
        getErrorMessages(e).forEach((m) => addToast("danger", m));
      });
  };

  return (
    <Modal open={!!vehicle} onClose={onCancel} className="w-[85vw] !p-6 md:w-[550px] lg:w-[550px]">
      {vehicle && (
        <div className="relative flex flex-col">
          {isLoading && <Loading />}
          <Typography variant="title">Confirm Vehicle Details</Typography>
          <Typography variant="paragraph" className="mt-1 text-neutral-dark-gray">
            Review the details below to make sure they match your vehicle
          </Typography>

          <div className="mt-5">
            <VehicleDetailsSummary vehicle={vehicle} />
          </div>

          <div className="mt-6 flex justify-end gap-3">
            <Button variant="secondary" size="md" onClick={onCancel} disabled={isLoading}>
              Cancel
            </Button>
            <Button variant="primary" size="md" onClick={handleConfirm} disabled={isLoading}>
              Confirm Vehicle
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};
